import { useChatContext } from '../../../context/ChatContext';

import type { BeloChat, UpdatedMessage } from 'belo-js-sdk';

import type { DefaultBeloChatGenerics, UpdateMessageOptions } from '../../../types/types';

type UpdateHandler<BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics> = (
  cid: string,
  updatedMessage: UpdatedMessage<BeloChatGenerics>,
  options?: UpdateMessageOptions,
) => ReturnType<BeloChat<BeloChatGenerics>['updateMessage']>;

export const useEditMessageHandler = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  doUpdateMessageRequest?: UpdateHandler<BeloChatGenerics>,
) => {
  const { channel, client } = useChatContext<BeloChatGenerics>('useEditMessageHandler');

  return (updatedMessage: UpdatedMessage<BeloChatGenerics>, options?: UpdateMessageOptions) => {
    if (doUpdateMessageRequest && channel) {
      return Promise.resolve(doUpdateMessageRequest(channel.cid, updatedMessage, options));
    }
    return client.updateMessage(updatedMessage, undefined, options);
  };
};
